import LinkForm from "./LinkForm"

const config = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: true,
				},
				toolbar: {
					display: true,
				},
				footer: {
					display: false,
				},
				leftSidePanel: {
					display: true,
				},
				rightSidePanel: {
					display: true,
				},
			},
		},
	},
	routes: [
		{
			path: "/internalurl",
			component: LinkForm,
		},
	],
};

export default config;
